import axios from 'axios'
import { getAuthData } from '@/helpers/auth'

const apiClient = axios.create({ baseURL: '/' })

apiClient.interceptors.request.use(config => {
  const authData = getAuthData()
  if (authData) {
    config.headers['access-token'] = authData['access-token']
    config.headers['token-type'] = authData['token-type']
    config.headers.client = authData.client
    config.headers.expiry = authData.expiry
    config.headers.uid = authData.uid
  }
  return config
})

export default apiClient
